module.exports = __webpack_public_path__ + "img/calendar-month.d2a727bd.svg";